import { ModelHelper } from '../classes/model-helper';

export class LabProfileShade {
	uid: string;
	guide: string;
	displayGuide: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns LabProfileShade
	 */
	static map(data: any, item: LabProfileShade = new LabProfileShade()): LabProfileShade {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return LabProfileShade
	 */
	public map(data: any): LabProfileShade {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'guide');
		ModelHelper.map(data, this, 'displayGuide');

		// When display guide is missing
		if (data['guide'] && !this.displayGuide) {
			ModelHelper.map(data, this, 'displayGuide', null, 'guide');
		}

		return this;
	}
}
